import { Component, inject, OnInit } from "@angular/core";
import { CommonModule, formatDate } from "@angular/common";
import { SVG_ICONS } from "../../models/icons";
import { SanitizerPipe } from "../../pipes/sanitizer.pipe";
import { FormsModule } from "@angular/forms";
import { MasterService } from "@frontend/app/serivces/master.service";
import { Router, RouterLink } from "@angular/router";
import { SharedModule } from "@frontend/app/shared/shared.module";

@Component({
  selector: "app-dashboard",
  standalone: true,
  imports: [CommonModule, SanitizerPipe, FormsModule, RouterLink, SharedModule],
  templateUrl: "./dashboard.component.html",
  styleUrl: "./dashboard.component.scss",
})
export class DashboardComponent implements OnInit {
  private masterService = inject(MasterService);
  private router = inject(Router);

  ngOnInit(): void {
    this.getStudents();
    this.getCoachList();
    this.getClassess();
    this.getStudentRevenue();
    this.getStudentExpiryDetails();
  }

  //#region variables

  readonly SVG_ICONS = SVG_ICONS;
  activeTab = "calendar";
  currentView: "day" | "week" | "month" = "week";
  timeSlots = ["5 AM", "6 AM", "7 AM", "8 AM", "9 AM", "10 AM", "11 AM", "12 PM", "1 PM", "2 PM", "3 PM", "4 PM", "5 PM", "6 PM", "7 PM", "8 PM", "9 PM"];
  weekDays: { name: string; number: string; fullDate: Date }[] = [];
  events: any[] = [];
  studentCount = 0;
  trainers = 0;
  classCount = 0;
  newClassCount = 0;
  monthAndYearDisplay = "";
  monthGrid: { day: number; isCurrentMonth: boolean; date: Date; events: any[] }[][] = [];
  currentDate: Date = new Date();

  studentRevenue = 0;
  revenuePercentage = 0;
  revenueStatus: "low" | "high" = "high";

  studentExpiryDetailsToday: any[] = [];
  studentExpiryDetailsSoon: any[] = [];
  newStudentCount = 0;
  newCoachCount = 0;
  upcomingClass: any = null;

  //#endregion

  getStudents() {
    this.masterService.getStudentCount(sessionStorage.getItem("selectedCenter") || "").subscribe((res: any) => {
      this.studentCount = res.count || 0;
      this.newStudentCount = res.currentMonthCount || 0;
    });
  }

  getStudentRevenue() {
    this.masterService.getStudentRevenue(sessionStorage.getItem("selectedCenter") || "").subscribe((res: any) => {
      console.log(res);
      // Handle both array response (wrapped in data property) or direct object
      // const data = res.data && res.data.length > 0 ? res.data[0] : res;

      this.studentRevenue = res.TotalRevenue;
      // const currentMonthRevenue = data.CurrentMonthRevenue || 0;
      // const lastMonthRevenue = data.LastMonthRevenue || 0;

      // if (lastMonthRevenue === 0) {
      //   this.revenuePercentage = currentMonthRevenue > 0 ? 100 : 0;
      // } else {
      //   this.revenuePercentage = ((currentMonthRevenue - lastMonthRevenue) / lastMonthRevenue) * 100;
      // }

      // this.revenueStatus = this.revenuePercentage >= 0 ? 'high' : 'low';
      // // Format to 1 decimal place for display
      // this.revenuePercentage = Math.abs(parseFloat(this.revenuePercentage.toFixed(1)));
    });
  }

  getStudentExpiryDetails() {
    this.masterService.getStudentExpiryDetails(sessionStorage.getItem("selectedCenter") || "").subscribe((res: any) => {
      this.studentExpiryDetailsToday = res.expiredToday || [];
      this.studentExpiryDetailsSoon = res.expiringSoon || [];
    });
  }

  getCoachList() {
    this.masterService.getCoachCount(sessionStorage.getItem("selectedCenter") || "", sessionStorage.getItem("UserTypeID") || "").subscribe((res: any) => {
      this.trainers = res.count || 0;
      this.newCoachCount = res.currentMonthCount || 0;
    });
  }

  onStudentDetails(studentID: number) {
    this.router.navigate(["student/student-details"], { queryParams: { StudentID: studentID } });
  }

  getClassess() {
    this.masterService.getClassCount(sessionStorage.getItem("selectedCenter") || "", sessionStorage.getItem("TrainerID") || "").subscribe((res: any) => {
      this.classCount = res.count || 0;
      this.newClassCount = res.currentMonthCount || 0;
    });

    this.masterService.getClassList(1, 1000, "", sessionStorage.getItem("selectedCenter") || "", "", sessionStorage.getItem("TrainerID") || "", "", "").subscribe((res: any) => {
      const { Table } = res;
      if (!Table) return;

      const storedIDs = sessionStorage.getItem("selectedCenter");
      const centerIDs: number[] = storedIDs ? JSON.parse(storedIDs) : [];

      const centerClasses = Table.filter((item: any) => item.CenterID != null && centerIDs.includes(item.CenterID));

      this.events = this.transformClassesToEvents(centerClasses);
      this.updateCalendarView();
      this.calculateUpcomingClass();
    });
  }

  calculateUpcomingClass() {
    const now = new Date();
    const candidates: any[] = [];

    for (let i = 0; i < 7; i++) {
      const date = new Date(now);
      date.setDate(now.getDate() + i);
      const dayName = formatDate(date, "E", "en-US").toUpperCase();
      const dateOnly = new Date(date);
      dateOnly.setHours(0, 0, 0, 0);

      for (const event of this.events) {
        const start = new Date(event.classStartDate);
        start.setHours(0, 0, 0, 0);
        const end = new Date(event.classEndDate);
        end.setHours(0, 0, 0, 0);

        if (event.dayName === dayName && dateOnly >= start && dateOnly <= end) {
          const [sH, sM] = event.startTime.split(":").map(Number);
          const [eH, eM] = event.endTime.split(":").map(Number);

          const instanceStart = new Date(date);
          instanceStart.setHours(sH, sM, 0, 0);

          const instanceEnd = new Date(date);
          instanceEnd.setHours(eH, eM, 0, 0);

          if (instanceEnd > now) {
            const startWindow = new Date(instanceStart);
            startWindow.setMinutes(startWindow.getMinutes() - 15);
            const endWindow = new Date(instanceEnd);
            endWindow.setMinutes(endWindow.getMinutes() + 30);
            const isAttendanceEnabled = now >= startWindow && now <= endWindow;

            candidates.push({
              ...event,
              instanceStart,
              instanceEnd,
              isAttendanceEnabled,
              displayDate: i === 0 ? "Today" : i === 1 ? "Tomorrow" : formatDate(date, "MMM d", "en-US"),
            });
          }
        }
      }
      if (candidates.length > 0) break;
    }

    candidates.sort((a, b) => a.instanceStart.getTime() - b.instanceStart.getTime());
    this.upcomingClass = candidates.length > 0 ? candidates[0] : null;
  }

  updateCalendarView() {
    this.monthAndYearDisplay = formatDate(this.currentDate, "MMMM yyyy", "en-US");
    switch (this.currentView) {
      case "day":
        this.setupDayView(this.currentDate);
        break;
      case "month":
        this.setupMonthView(this.currentDate);
        break;
      default:
        this.setupWeekView(this.currentDate);
    }
  }

  isToday(date: Date): boolean {
    const today = new Date();
    return date.getFullYear() === today.getFullYear() && date.getMonth() === today.getMonth() && date.getDate() === today.getDate();
  }

  setupWeekView(date: Date) {
    this.weekDays = [];

    const startDate = new Date(date);
    startDate.setHours(0, 0, 0, 0);

    for (let i = 0; i < 7; i++) {
      const day = new Date(startDate);
      day.setDate(startDate.getDate() + i);

      this.weekDays.push({
        name: formatDate(day, "E", "en-US").toUpperCase(),
        number: formatDate(day, "dd", "en-US"),
        fullDate: day,
      });
    }
  }

  setupDayView(date: Date) {
    this.weekDays = [
      {
        name: formatDate(date, "E", "en-US").toUpperCase(),
        number: formatDate(date, "dd", "en-US"),
        fullDate: date,
      },
    ];
  }

  setupMonthView(date: Date) {
    this.monthGrid = [];
    const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    const firstDayOfWeek = firstDayOfMonth.getDay();
    const currentDay = new Date(firstDayOfMonth);
    currentDay.setDate(currentDay.getDate() - firstDayOfWeek);

    let weeks: { day: number; isCurrentMonth: boolean; date: Date; events: any[] }[][] = [];
    let safety = 0;
    while (weeks.length < 6 && safety < 10) {
      const week: { day: number; isCurrentMonth: boolean; date: Date; events: any[] }[] = [];
      for (let i = 0; i < 7; i++) {
        const dayName = formatDate(currentDay, "E", "en-US").toUpperCase();
        const normalizedCurrentDay = new Date(currentDay);
        normalizedCurrentDay.setHours(0, 0, 0, 0);

        const dayEvents = this.events.filter(e => {
          const eventRunsOnThisDay = e.dayName === dayName;
          const startDate = new Date(e.classStartDate);
          startDate.setHours(0, 0, 0, 0);
          const endDate = new Date(e.classEndDate);
          endDate.setHours(0, 0, 0, 0);
          const isDateActive = normalizedCurrentDay >= startDate && normalizedCurrentDay <= endDate;
          return eventRunsOnThisDay && isDateActive;
        });

        week.push({
          day: currentDay.getDate(),
          isCurrentMonth: currentDay.getMonth() === date.getMonth(),
          date: new Date(currentDay),
          events: dayEvents,
        });
        currentDay.setDate(currentDay.getDate() + 1);
      }
      weeks.push(week);
      safety++;
    }
    this.monthGrid = weeks;
  }

  setView(view: "day" | "week" | "month") {
    this.currentView = view;
    this.updateCalendarView();
  }

  navigateDate(direction: number) {
    const newDate = new Date(this.currentDate);
    switch (this.currentView) {
      case "day":
        newDate.setDate(newDate.getDate() + direction);
        break;
      case "week":
        newDate.setDate(newDate.getDate() + 7 * direction);
        break;
      case "month":
        newDate.setMonth(newDate.getMonth() + direction);
        break;
    }
    this.currentDate = newDate;
    this.updateCalendarView();
  }

  goToToday() {
    this.currentDate = new Date();
    this.updateCalendarView();
  }

  private toLocalDate(iso: string | undefined | null): Date | null {
    if (!iso) return null;
    return new Date(iso);
  }

  private normalizeDayName(dayName: string) {
    return (dayName || "").toString().toUpperCase();
  }

  transformClassesToEvents(classes: any[]): any[] {
    const events: any[] = [];

    for (const cls of classes) {
      if (!cls.ClassStartDate || !cls.ClassEndDate) {
        continue;
      }
      const classStartDate = this.toLocalDate(cls.ClassStartDate);
      const classEndDate = this.toLocalDate(cls.ClassEndDate);

      const days = Array.isArray(cls.Days) ? cls.Days : [];

      if (days.length === 0) {
        continue;
      }

      for (const d of days) {
        const dayName = this.normalizeDayName(d.DayName || "");
        if (!dayName) continue;

        const startDateTimeLocal = this.toLocalDate(d.StartTime);
        const endDateTimeLocal = this.toLocalDate(d.EndTime);

        const sDT = startDateTimeLocal ?? classStartDate!;
        const eDT = endDateTimeLocal ?? new Date(sDT.getTime() + 60 * 60 * 1000);

        const pad = (n: number) => n.toString().padStart(2, "0");
        const startHHMM = `${pad(sDT.getHours())}:${pad(sDT.getMinutes())}`;
        const endHHMM = `${pad(eDT.getHours())}:${pad(eDT.getMinutes())}`;

        const endAmPm = formatDate(eDT, "a", "en-US");
        const startAmPm = formatDate(sDT, "a", "en-US");
        const startDisplayFmt = startAmPm === endAmPm ? "h:mm" : "h:mm a";

        events.push({
          id: `${cls.ClassID}-${dayName}`,
          classId: cls.ClassID,
          title: cls.ClassName,
          CenterName: cls.CenterName,
          color: this.getRandomColor(),
          startTime: startHHMM,
          endTime: endHHMM,
          displayStartTime: formatDate(sDT, startDisplayFmt, "en-US"),
          displayEndTime: formatDate(eDT, "h:mm a", "en-US"),
          dayName,
          classStartDate,
          classEndDate,
          participants: cls.Students?.length || 0,
          rawClass: cls,
        });
      }
    }
    return events;
  }

  setActiveTab(tab: string) {
    this.activeTab = tab;
  }

  getEventsForDay(dayIndex: number): any[] {
    const dayInfo = this.weekDays[dayIndex];
    if (!dayInfo) return [];
    const dayName = dayInfo.name;
    const currentDate = new Date(dayInfo.fullDate);
    currentDate.setHours(0, 0, 0, 0);

    return this.events.filter(e => {
      const eventRunsOnThisDay = e.dayName === dayName;
      const startDate = new Date(e.classStartDate);
      startDate.setHours(0, 0, 0, 0);
      const endDate = new Date(e.classEndDate);
      endDate.setHours(0, 0, 0, 0);
      const isDateActive = currentDate >= startDate && currentDate <= endDate;
      return eventRunsOnThisDay && isDateActive;
    });
  }

  getEventPosition(time: string): number {
    if (!time) return 0;
    const [hours, minutes] = time.split(":");
    const hour = parseInt(hours, 10);
    const mins = parseInt(minutes, 10);

    if (isNaN(hour) || isNaN(mins)) return 0;

    const startHour = 5;
    const hourHeight = 80;

    const hourOffset = (hour - startHour) * hourHeight;
    const minuteOffset = (mins / 60) * hourHeight;

    return Math.max(0, hourOffset + minuteOffset);
  }

  getEventHeight(startTime: string, endTime: string): number {
    if (!startTime || !endTime) return 0;
    const startPos = this.getEventPosition(startTime);
    const endPos = this.getEventPosition(endTime);
    const height = endPos - startPos;
    return Math.max(20, height);
  }

  getRandomColor(): string {
    const colors = ["#6d4c41", "#ec407a", "#8d6e63", "#689f38"];
    return colors[Math.floor(Math.random() * colors.length)];
  }

  getGroupedEventsForDay(dayIndex: number): any[] {
    const events = this.getEventsForDay(dayIndex);
    if (!events.length) return [];

    const groups: Map<string, any[]> = new Map();

    for (const event of events) {
      const key = event.startTime;
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key)!.push(event);
    }

    const groupedArray = Array.from(groups.entries()).map(([startTime, eventList]) => {
      const firstEvent = eventList[0];
      return {
        startTime: firstEvent.startTime,
        endTime: firstEvent.endTime,
        top: this.getEventPosition(firstEvent.startTime),
        height: this.getEventHeight(firstEvent.startTime, firstEvent.endTime),
        events: eventList,
      };
    });

    return groupedArray.sort((a, b) => a.top - b.top);
  }

  onAttendance(classId: number) {
    this.router.navigate(["/attendance"], {
      queryParams: {
        ClassID: classId,
      },
    });
  }

  isAttendanceActive(event: any, date: Date): boolean {
    if (!this.isToday(date)) return false;

    const now = new Date();
    const [startHour, startMin] = event.startTime.split(":").map(Number);
    const [endHour, endMin] = event.endTime.split(":").map(Number);

    const windowStart = new Date(now);
    windowStart.setHours(startHour, startMin, 0, 0);
    windowStart.setMinutes(windowStart.getMinutes() - 15);

    const windowEnd = new Date(now);
    windowEnd.setHours(endHour, endMin, 0, 0);
    windowEnd.setMinutes(windowEnd.getMinutes() + 30);

    return now >= windowStart && now <= windowEnd;
  }

  isUpcomingAttendanceEnabled(upcoming: any): boolean {
    if (!upcoming) return false;
    const now = new Date();
    const startWindow = new Date(upcoming.instanceStart);
    startWindow.setMinutes(startWindow.getMinutes() - 15);
    const endWindow = new Date(upcoming.instanceEnd);
    endWindow.setMinutes(endWindow.getMinutes() + 30);
    return now >= startWindow && now <= endWindow;
  }

  onActionClick(studentID: number) {
    this.router.navigate(["student/student-details"], { queryParams: { StudentID: studentID } });
  }
}
